import { UserPlus, XCircle } from 'phosphor-react'
import { useEffect, useMemo, useState } from 'react'
import { Form, Modal, Table } from 'react-bootstrap'
import { CaretDown, CaretUp } from 'react-bootstrap-icons'
import { Center } from '../../../../components/Center'
import { CustomButton } from '../../../../components/CustomButton'
import { CustomSpinner } from '../../../../components/CustomSpinner'
import { useOrderTable } from '../../../../hooks/useOrderTable'
import apinode from '../../../../services/apinode'
import WmsOsService from '../../../../services/database/WmsOsService'
import { sendErrorApiMessage } from '../../../../utils/sendErrorApiMessage'

export function ModalFunc({ isOpen, onClose, onSuccess, selectedOs }) {
  const [search, setSearch] = useState('')
  const [employees, setEmployees] = useState([])
  const [isEmployeesLoading, setIsEmployeesLoading] = useState(true)
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null)
  const [isAssignEmployeeLoading, setIsAssignEmployeeLoading] = useState(false)

  const {
    sortedArray: sortedFuncionarios,
    check,
    handleOrganize,
    orderType,
  } = useOrderTable(employees, 'NOMEFUNCIONARIO', 'asc')

  const filteredFuncionarios = useMemo(() => {
    return sortedFuncionarios.filter((funcionario) =>
      String(funcionario.NOMEFUNCIONARIO)
        .toLowerCase()
        .includes(String(search.toLowerCase())),
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, sortedFuncionarios, orderType.field, orderType.type])

  async function loadFuncionarios() {
    try {
      setIsEmployeesLoading(true)

      const response = await apinode.get(
        `/funcionarios/${localStorage.idconta}`,
      )

      setEmployees(response.data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível carregar os funcionários!')
    } finally {
      setIsEmployeesLoading(false)
    }
  }

  async function handleAddFuncionario() {
    try {
      setIsAssignEmployeeLoading(true)

      await WmsOsService.assignEmployee(selectedOs, selectedEmployeeId)

      onSuccess()
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível atribuir a OS ao funcionário')
    } finally {
      setIsAssignEmployeeLoading(false)
    }
  }

  useEffect(() => {
    loadFuncionarios()
  }, [])

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      dialogClassName="custom-modalzpl"
    >
      <Modal.Header closeButton>
        <Modal.Title>Atribuir à</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {isEmployeesLoading ? (
          <Center>
            <CustomSpinner size={32} />
          </Center>
        ) : (
          <>
            <Form.Control
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Digite o nome..."
            />

            <Table
              hover
              striped
              borderless
              responsive
            >
              <thead>
                <tr>
                  <th>Selec.</th>
                  <th onClick={() => handleOrganize('IDFUNCIONARIO')}>
                    <span>ID</span>
                    <CaretUp color={check('IDFUNCIONARIO', 'asc')} />
                    <CaretDown color={check('IDFUNCIONARIO', 'desc')} />
                  </th>
                  <th onClick={() => handleOrganize('NOMEFUNCIONARIO')}>
                    <span>Nome</span>
                    <CaretUp color={check('NOMEFUNCIONARIO', 'asc')} />
                    <CaretDown color={check('NOMEFUNCIONARIO', 'desc')} />
                  </th>
                </tr>
              </thead>

              <tbody>
                {filteredFuncionarios.map((funcionario) => (
                  <tr
                    key={funcionario.IDFUNCIONARIO}
                    style={{ cursor: 'pointer' }}
                  >
                    <td>
                      <Form.Check
                        checked={
                          selectedEmployeeId === funcionario.IDFUNCIONARIO
                        }
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedEmployeeId(funcionario.IDFUNCIONARIO)
                          } else {
                            setSelectedEmployeeId(null)
                          }
                        }}
                      />
                    </td>
                    <td>{funcionario.IDFUNCIONARIO}</td>
                    <td>{funcionario.NOMEFUNCIONARIO}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <CustomButton
          title="Atribuir"
          r
          isDisabled={!selectedEmployeeId}
          onClick={handleAddFuncionario}
          isLoading={isAssignEmployeeLoading}
          isLoadingText="Atribuindo..."
        >
          <UserPlus size={20} />
        </CustomButton>

        <CustomButton
          isDelete
          onClick={onClose}
          title="Fechar"
        >
          <XCircle size={20} />
        </CustomButton>
      </Modal.Footer>
    </Modal>
  )
}
